import { useGetJourneyMetricUsage } from 'modules/journey/hooks/useGetJourneyMetricUsage';
import { getIsInProgressTotalPublishedView } from 'modules/workflows';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { BannerBodyBase, BannerTitleBase } from 'ui/banner/Banner.styles';

export const JOURNEY_USAGE_WARNING_TEST_ID = 'journey-usage-warning-banner';

const StyledWarningBanner = styled(WarningBanner)`
align-items: flex-start !important;
`;

export const JourneyUsageWarningBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const isInProgressTotalPublishedViewEnabled = useSelector(getIsInProgressTotalPublishedView);
  const { currentUsage, currentUsagePercentage, limit } = useGetJourneyMetricUsage();

  useEffect(() => {
    if (currentUsagePercentage > 90) {
      setShowBanner(true);
    }
  }, [currentUsagePercentage]);

  return (
    <>
      {isInProgressTotalPublishedViewEnabled && showBanner && (
        <StyledWarningBanner
          data-test={JOURNEY_USAGE_WARNING_TEST_ID}
          onClose={() => setShowBanner(false)}
        >
          <BannerTitleBase>
            You’ve reached {currentUsagePercentage}% ({currentUsage?.toLocaleString()} /{' '}
            {limit?.toLocaleString()} events) of your monthly limit for tracking journey events.
          </BannerTitleBase>
          <br />
          <BannerBodyBase>
            Journey event tracking turns off on all journeys when you've hit 100% of your limit.
            Need to track more journey events? Contact your CSM to update your plan limit.
          </BannerBodyBase>
        </StyledWarningBanner>
      )}
    </>
  );
};
